import { render, staticRenderFns } from "./managePostageList.vue?vue&type=template&id=386ccdd7&"
import script from "./managePostageList.vue?vue&type=script&lang=js&"
export * from "./managePostageList.vue?vue&type=script&lang=js&"
import style0 from "./managePostageList.vue?vue&type=style&index=0&id=386ccdd7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports